import { render, staticRenderFns } from "./AtTips.vue?vue&type=template&id=49d8ce98&scoped=true&"
import script from "./AtTips.vue?vue&type=script&lang=js&"
export * from "./AtTips.vue?vue&type=script&lang=js&"
import style0 from "./AtTips.vue?vue&type=style&index=0&id=49d8ce98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8ce98",
  null
  
)

export default component.exports